
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  resetPasswordFormButton: {
    id: "ResetPasswordForm.button",
    defaultMessage: "Reset password",
  },
});

export default MESSAGES;